import loadDriver from './load-driver.js';

const fetchTransactionInfo = async (theapp, settings_entry, txhash) => {
	console.log('fetchTransactionInfo called');

	if (!settings_entry)
	return;

	let tx_info;

	try {
		var rootsessionuuid = await theapp.getRootSessionUUID();
		var devicewallet = await theapp.getDeviceWallet();
		var walletuuid = devicewallet.uuid;

		let context = { _refresh_page: false};


		await theapp.getCurrencyContext(context, settings_entry);

		let currentscheme = context.currentscheme;

		if (currentscheme) {
			let remotewallet = await loadDriver(theapp);

			tx_info = await remotewallet.getTransactionInfo(rootsessionuuid, walletuuid, currentscheme.uuid, txhash);
		}
	}
	catch(e) {
		console.log('exception in fetchTransactionInfo: ' + e);
	}

	return tx_info;
}

export default fetchTransactionInfo;